// Effective Estimator quantity for a row: the qty-box override when the user has entered one,
// otherwise the source (contract/itemized) quantity.
export const getEffectiveQty = (qtyEdits, key, sourceQty) => {
  const edited = qtyEdits ? qtyEdits[key] : undefined;
  if (edited !== undefined && edited !== '') return parseFloat(edited) || 0;
  return parseFloat(sourceQty) || 0;
};

// Save-payload fragment for a line item's quantity. Include `quantity` for every row that
// currently carries an override — a value typed into the qty box this session, or a previously
// saved override reloaded from estimateDiscount.lineItems — so the override is re-sent on every
// Save. The backend resets a line's qty whenever the key is absent, so re-sending is what stops a
// prior override from being wiped when the user saves after editing a *different* item. Rows with
// no override omit the key and stay at the source quantity. A manually entered 0 is a genuine
// override (estimator wants the line saved at 0). The backend treats a falsy quantity as "use the
// default qty", so a 0 override is tagged with isQtyZero:true — the explicit signal that tells the
// backend to persist/return 0 for this line. Positive overrides carry no flag.
export const buildQtyPayloadField = (qtyEdits, key, sourceQty) => {
  const raw = qtyEdits ? qtyEdits[key] : undefined;
  if (raw === undefined || raw === '') return {};
  const effective = getEffectiveQty(qtyEdits, key, sourceQty);
  return effective === 0 ? { quantity: 0, isQtyZero: true } : { quantity: effective };
};
